<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      :z-index="10"
      @click-left="goableBack()"
      title="消息中心"></van-nav-bar>
    <div class="container">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad">
          <div
            class="item"
            v-for="n in list"
            :key="n.id"
            @click="
              $router.push({ name: 'notify-view', params: { id: n.id } })
            ">
            <div class="top-bg">
              <div class="title">
                {{ n.title }} <span class="dot" v-if="n.readStatus == 0"></span>
              </div>
              <div class="time">{{ dateTime(n.createTime) }}</div>
            </div>
            <div class="van-ellipsis content">{{ n.mesContent }}</div>
            <!-- <div class="van-ellipsis content" v-html="n.mesContent"></div> -->
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { PullRefresh, List, Badge } from "vant"
import { list } from "@/api/msg"
import moment from "moment"
export default {
  data: () => ({
    list: [],
    loading: false,
    finished: false,
    refreshing: false,
    form: {
      pageNo: 1,
      pageSize: 10
    }
  }),
  methods: {
    dateTime(createTime) {
      let date = new Date(moment(createTime).format("YYYY/MM/DD HH:mm:ss"))
      let today = new Date()
      let diff = today.getTime() - date.getTime() // 时间差的毫秒数
      let dayDiff = Math.floor(diff / (24 * 3600 * 1000)) // 计算出相差天数
      if (dayDiff === 0) {
        return moment(createTime).format("HH:mm:ss")
      } else {
        return moment(createTime).format("YYYY-MM-DD HH:mm:ss")
      }
    },
    onLoad() {
      this.loadData()
    },
    onRefresh() {
      this.form.pageNo = 1
      this.loadData(true)
    },

    loadData(refresh) {
      this.loading = true

      list(this.form.pageNo, this.form.pageSize)
        .then((data) => {
          if (refresh) {
            this.list = data
          } else {
            this.list.push.apply(this.list, data)
          }
          this.form.pageNo++
          this.finished = data.length < this.form.pageSize
          this.loading = false
          this.refreshing = false
        })
        .catch((e) => {
          this.loading = false
          this.refreshing = false
          console.error(e)
        })
    }
  },
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Badge.name]: Badge
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 10px;
}
.item {
  background: #fff;
  padding: 10px;
  border-radius: 3px;
  margin-bottom: 10px;
  .top-bg {
    display: flex;
    justify-content: space-between;
    .title {
      font-weight: bold;
    }
    .dot {
      margin-left: 5px;
      display: inline-block;
      background: red;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      position: relative;
      top: -1px;
    }
    .time {
      color: @gray-dark;
    }
  }
  .content {
    margin-top: 10px;
    color: @gray-dark;
    width: 100%;
    display: block;
    white-space: nowrap;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
